<template>
  <div class="wrapper">
    <p class="title">이용약관</p>
    <div>
      <p class="text0">AI튜터 Plus 이용약관</p>
      <p class="text1">{{ text }}</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: `제 1장 총칙
  
 제1조 (목적)
 이 약관은 ㈜캐럿솔루션즈(이하 “AI튜터 Plus”)에서 제공하는 서비스를 이용함에 있어 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
  
 제2조 (용어의 정의)
 이 약관에서 사용되는 용어의 정의는 다음 각 호와 같습니다.
 이용자 : 이용자란 웹사이트에 접속하여 이 약관에 따라 AI튜터 Plus가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.
 회원 : 회원이란 AI튜터 Plus에 개인정보를 제공하여 회원등록을 한 자로서, AI튜터 Plus의 서비스를 지속적으로 제공받으며, AI튜터 Plus가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
 수강 신청 : 수강신청이란 회원이 AI튜터 Plus에서 제공하는 온라인 유/무료 서비스를 이용하기 위하여 AI튜터 Plus가 정한 별도의 기준 및 절차에 따라 이용을 신청하는 것을 의미합니다.
 수강료 : AI튜터 Plus가 제공하는 유료강의를 이용하기 위한 대가로 AI튜터 Plus가 정한 별도의 요금체계에 의해 특정기간 단위로 부과 되는 금액을 의미합니다.
 수강 승인 : 회원이 AI튜터 Plus에게 수강신청을 요구하고 AI튜터 Plus가 유/무료강의 이용을 승인하는 것을 의미합니다.
 
  
 제3조 (약관의 효력과 변경 등)
 1. 본 약관은 서비스를 이용하기를 희망하는 회원이 동의함으로써 효력이 발생하며, 회원이 이 약관에 대하여 “동의하기” 버튼을 클릭한 경우, 이 약관의 내용을 충분히 이해하고 그 적용에 동의한 것으로 간주합니다.
  
 2. 회사는 전자상거래 등에서의 「소비자보호에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련법을 위배하지 않는 범위에서 약관을 개정할 수 있습니다. AI튜터 Plus가 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 AI튜터 Plus 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.
  
 3. 회사가 제2항의 공지 또는 통보를 하면서 개정 약관의 적용시행일까지 회원이 거부 의사를 표시하지 아니할 경우 약관의 개정에 동의한 것으로 간주한다는 내용을 고지하였으나, 회원이 명시적으로 약관 변경에 대한 거부의사를 표시하지 아니하면, 회사는 회원이 적용시행일자 부로 변경 약관에 동의한 것으로 간주합니다. 개정 또는 변경 약관에 대하여 거부의사를 표시한 회원은 계약의 해지 또는 회원 탈퇴를 선택할 수 있습니다.
  
 4. 이 약관은 회원이 이 약관에 동의한 날로부터 회원 탈퇴 시까지 적용하는 것을 원칙으로 합니다. 단, 이 약관의 일부 조항은 회원이 탈퇴 후에도 유효하게 적용될 수 있습니다.
  
 5. 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 정부가 제정한 전자거래소비자보호지침 및 관계법령 또는 상관례에 따릅니다.
  
 제 4 조(서비스의 제공 및 변경)
 1. AI튜터 Plus는 다음과 같은 업무를 수행합니다.
 학습정보 제공과 유/무료 서비스 정보제공 및 구매계약의 체결
 구매계약이 체결된 온라인 유/무료 서비스 제공
 기타 AI튜터 Plus가 정하는 업무
 2. AI튜터 Plus는 AI튜터 Plus가 제공하는 서비스 및 기술적 사양 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 서비스 내용을 변경할 수 있습니다. 이 경우에는 변경된 서비스의 내용 및 AI튜터 Plus 초기화면에 그 제공일자 이전 7일부터 공지합니다.
 3. AI튜터 Plus가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 AI튜터 Plus의 내부적인 사유로 변경할 경우에는 AI튜터 Plus는 이로 인하여 이용자가 입은 손해를 배상합니다. 단, AI튜터 Plus의 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.
  
 제 5 조(서비스의 중단)
 1. AI튜터 Plus는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
 2. 제 1항에 의한 서비스 중단의 경우에는 AI튜터 Plus는 제 8조에 정한 방법으로 이용자에게 통지합니다.
 3. AI튜터 Plus는 제 1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제 3자가 입은 손해에 대하여 배상합니다. 단, AI튜터 Plus의 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.
  
 제 6 조(회원가입)
 회원가입은 이용자가 약관의 내용에 대하여 동의를 하고 회원 가입 신청을 한 후 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
  
 회원가입신청서에는 다음 사항을 기재해야 합니다. 1호 내지 2호의 사항은 필수 사항이며, 그 외의 사항은 선택 사항입니다.
 회원의 성명
 이메일(ID)과 비밀번호
 기타 회사가 필요하다고 인정하는 사항
  
 3. 회사는 상기 이용자의 신청에 대하여 회원가입을 승낙함을 원칙으로 합니다. 다만, 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않을 수 있습니다.
 실명이 아니거나 타인의 명의를 이용하여 신청한 경우
 등록내용에 허위, 기재누락, 오기가 있는 경우
 사회의 안녕과 질서, 미풍양속을 저해할 목적으로 신청한 경우
 부정한 용도로 본 서비스를 이용하고자 하는 경우
 영리를 추구할 목적으로 본 서비스를 이용하고자 하는 경우
 기타 회사가 정한 등록신청 요건이 미비된 경우
 가입신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우
 기타 회원으로 등록하는 것이 AI튜터 Plus의 기술상 현저한 지장이 있다고 판단되는 경우
 회사는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
  
 제3항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 회사는 이를 신청자에게 전자우편, 기타 방법으로 알려야 합니다. 회사의 귀책사유 없이 신청자에게 통지할 수 없는 경우에는 예외로 합니다.
  
 회원가입 계약의 성립 시기는 회사의 승낙이 이용자에게 도달한 시점으로 합니다.
  
 제 7 조(회원탈퇴 및 자격 상실 등)
 1. 회원은 AI튜터 Plus에 언제든지 탈퇴를 요청할 수 있으며 AI튜터 Plus는 즉시 회원탈퇴를 처리합니다.
 2. 회원이 다음 각 호의 사유에 해당하는 경우, AI튜터 Plus는 회원자격을 제한 및 정지시킬 수 있습니다.
 ① 가입 신청 시에 허위 내용을 등록한 경우
 ② AI튜터 Plus를 이용하여 구입한 재화, 용역 등의 대금, 기타 AI튜터 Plus 이용에 관련하여 
 회원이 부담하는 채무를 기일에 지급하지 않는 경우
 ③ 다른 사람의 AI튜터 Plus 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우
 ④ AI튜터 Plus를 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
 3. AI튜터 Plus가 회원자격을 제한, 정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 는AI튜터 Plus는 회원자격을 상실 시킬 수 있습니다.
 4. 주)캐럿솔루션즈가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 소명할 기회를 부여합니다.
  
 제 8 조(회원에 대한 통지)
 1. AI튜터 Plus는 회원에 대한 통지를 하는 경우, 회원이 AI튜터 Plus에 제출한 전자우편 주소 및 SMS로 할 수 있습니다.
 2. AI튜터 Plus는 불특정다수 회원에 대한 통지의 경우 1주일이상 AI튜터 Plus 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.
  
 제 9 조(수강신청)
 1. 회원은 AI튜터 Plus가 지정한 수강신청서를 작성, 제출함으로써 온라인 유/무료 강의를 수강신청 할 수 있습니다.
 2.  AI튜터 Plus는 수강신청에 대하여 다음 각 호에 해당하지 않는 한 수강신청을 승낙합니다.
 ① 신청 내용에 허위, 기재누락, 오기가 있는 경우
 ② 수강신청에 승낙하는 것이 AI튜터 Plus 기술상 현저히 지장이 있다고 판단하는 경우
  
  
 제 10 조 (회원탈퇴 및 자격 상실 등)
 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다. 단, 탈퇴한 회원은 탈퇴일로부터 동일한 아이디로 회원가입을 할 수 없습니다.
  
 회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.
 가입신청 시에 허위내용을 등록한 경우
 다른 사람의 회사의 서비스이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우
 회사를 이용하여 법령 또는 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
  
 회사가 회원자격을 제한․정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을 상실시킬 수 있습니다.
  
 회사가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.
  
 제 2장 서비스 이용 계약
  
 제 11 조 (서비스 이용계약의 성립 및 승낙의 제한)
  
 서비스에 대한 이용계약은 이 약관에 동의한다는 의사표시(동의함을 선택)와 함께 이용 신청을 하고 회사가 이를 승낙함으로써 비로소 성립합니다.
  
 회원은 서비스 이용계약을 체결하기 전에 해당 서비스에 대하여 이 약관에서 회사가 명시, 고지하는 사항을 숙지하고, 착오 없이 정확히 거래할 수 있도록 하여야 합니다.
  
 회사와 회원 간 서비스 이용계약은 회사의 승낙이 회원에게 도달한 시점(유료서비스의 “구매․결제완료 등”의 표시가 회원에게 절차상 표시된 시점)에 성립합니다.
  
 회사는 서비스 이용약관 제8조(이용신청에 대한 승낙의 제한)에서 정하는 사유가 발생하는 경우, 이용신청을 승낙하지 아니하거나 소정의 조건 성취 또는 제한 사유가 해소될 때까지 일정 기간 동안 승낙을 유보할 수 있습니다.
  
 회원은 유료서비스 이용 신청을 위한 제반 사항을 기재할 경우 회원의 현재의 사실과 일치하는 정보를 기재하여야 하며, 회원이 이용하고자 하는 유료서비스의 결제방법의 선택 및 선택한 결제방법에 필요한 결제정보를 정확히 회사에 제공하여야 하며, 해당 사항이 변경될 경우 지체없이 회사가 정한 절차에 따라 변경사항을 고지, 반영하여야 합니다.
  
 회사는 본 이용약관 제6조(이용신청)의 기재사항 이외에 회원의 서비스 이용에 필요한 최소한의 정보를 수집할 수 있습니다. 이를 위해 회사가 문의한 사항에 대해 회원은 성실하게 고지합니다. 회사는 이 경우 수집하는 회원의 정보를 본 이용약관, 개인정보취급방침 및 정보통신망의 이용촉진 및 정보보호 등에 관한 법률이 정한 바에 따라 이용, 관리합니다.
  
 
  
 제 3 장 유료 서비스의 이용
  
 제 12 조 (유료 서비스 결제 및 이용)
 유료서비스 결제는 앱마켓(구글 플레이스토어 및 애플 앱스토어)의 인앱결제 서비스를 통해 정기결제의  방식으로 이루어지며, 유료서비스의 결제 또는 과오납금의 환불, 이용계약의 해제 또는 해지, 서비스의 결함으로 인하여 발생하는 손해의 보상 등에 관하여는 결제가 이루어지는 해당 앱마켓의 이용약관 규정이 적용됩니다.
 구독권 최초 결제 후, 차월 결제일은 구독 신청한 날과 동일한 날짜에 이루어집니다. 만약, 특정월에 결제일이 존재하지 않는 경우에는 해당 월 말일에 결제됩니다.
 정기 결제(구독) 갱신을 중단하고자 할 경우, 차월 자동 결제일 하루 전까지는 구독을 해지해야 합니다. 이 경우 다음 결제 예정일까지 서비스 사용이 가능하며, 중도 해지 시 일부 환불은 불가합니다.
 회사는 유료서비스 구독 권에 대한 변경이 있게 될 경우, 이 약관 제4조(약관의 효력/변경 등)가 정하는 방법에 따라 그 사실 및 내용, 변경일자를 사전에 알립니다.
 회원이 해외에서 앱의 제반 서비스 및 이용권을 이용하게 되는 경우 회원과 회원이 가입한 해당 통신사간에 체결된 통신 요금제에 의한 별도의 데이터 통화료가 발생합니다. 이 경우 발생하는 데이터 통화료는 회원과 해당 통신사 간에 체결된 통신요금제에 따라 과금 및 청구, 수납되므로, 데이터 통화료 분에 대해 ㈜캐럿솔루션즈는 어떠한 책임도 지지 않습니다.
  
  
 제4장 계약당사자의 의무, 손해배상 등
  
 제13조 (회원의 의무, 위반시 회사의 조치 등)
  
 회원은 회사가 제공하는 유료서비스 이용 시 관계법령, 약관, 세부이용지침, 서비스 이용안내 및 사이트 내 공지한 주의사항, 회사가 서비스 이용과 관련하여 회원에게 통지하는 사항 등을 준수하여야 하며, 기타 회사 및 타인의 명예를 훼손하거나 서비스 운영 기타 업무수행에 지장을 초래하는 행위를 해서는 안됩니다.
  
 회원은 아이디 및 비밀번호를 관리할 책임이 있으며, 본인이 아닌 타인이 사용하게 하여서는 안됩니다. 이를 위반하여 회원의 개인정보를 타인이 사용하여 유료서비스를 이용함으로써 발생한 결과에 대한 책임은 회원에게 있습니다. 회원은 타인의 명의, 아이디, 비밀번호, 휴대폰번호, 계좌번호, 신용카드번호 등 개인정보를 도용하거나 부정하게 사용하여서는 안됩니다.
  
 회원은 회사가 사전에 허용한 경우를 제외하고는 유료서비스를 영업활동 등 영리목적으로 이용하거나 이 약관에서 금지하는 행위를 하거나 허용하는 범위를 벗어난 이용행위를 하여서는 안됩니다.
  
 회원은 유료서비스 이용과정에서 위법행위 또는 선량한 풍속 기타 사회질서에 반하는 행위를 하여서는 안됩니다.
  
 회원은 유료서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 서비스의 이용 이외의 목적으로 사용하여서는 안됩니다.
  
 회사는 제1항 내지 제6항의 회원의 위반 행위가 있는 경우 해당 회원에 대하여 위반 사실을 고지하고 서비스 제공을 1개월간 정지시킬 수 있고, 동위반행위가 재발할 경우 서비스 이용계약을 해제 또는 해지할 수 있습니다. 본 항의 회사의 의사표시는 회원에게 도달한 날로부터 효력이 발생합니다. 회사의 해제, 해지 및 이용 정지에 대하여 회원은 회사가 정한 절차에 따라 이의신청 할 수 있습니다. 이 경우 이용자가 자신의 고의, 과실 없었음을 입증하거나 회원의 이의가 정당하다고 회사가 인정하는 경우 회사는 계정을 정지한 기간만큼 이용기간을 연장합니다.
  
 유료서비스 이용과 관련하여 진실한 정보를 입력하지 않은 회원은 법적인 보호를 받을 수 없으며, 서비스 이용에 제한을 받을 수 있습니다.
  
  
 제 14조 (손해배상)
  
 회사는 서비스의 결함에 의하여 회사가 제공하는 유료서비스의 내용인 콘텐츠가 손상, 훼손, 삭제되어 서비스 이용에 손해를 입은 회원에게 해당 콘텐츠의 복원으로 배상합니다. 회원에게 손해가 발생한 경우 회사는 회원에게 실제 발생한 손해만을 배상합니다. 다만, 회사의 고의 또는 과실 없이 회원에게 발생한 일체의 손해에 대하여는 책임을 지지 아니합니다. 회사는 이 약관에서 명시되지 아니한 회사의 귀책사유로 인하여 유료서비스의 이용 회원에게 손해가 발생한 경우 회사의 배상 책임과 관련하여 회사는 「콘텐츠 이용자 보호지침」의 관련 규정 및 기타 상관례를 따릅니다.
  
 고객이 이 약관의 이용 제한 관련 각 규정에 근거, 서비스의 이용이 제한되거나 이용계약이 해지된 경우, 고객이 보유한 모든 디지털 콘텐츠의 사용권은 상실되며 회사는 해당 디지털 콘텐츠의 구매대금을 반환할 의무를 부담하지 아니합니다.
  
 회원이 이 약관상의 의무를 위반함으로 인하여 회사에 손해가 발생한 경우 또는 회원이 유료 서비스를 이용함에 있어 회사에 손해를 입힌 경우, 회원은 회사에 그 손해를 배상하여야 합니다.
  
 제15조 (면책)
  
 회사는 다음 각 호의 사유로 인하여 회원 또는 제3자에게 발생한 손해에 대하여는 그 책임을지지 아니합니다.
  
 천재지변 또는 이에 준하는 불가항력으로 인해 유료서비스를 제공할 수 없는 경우
 회원이 자신의 아이디 또는 비밀번호 등의 관리를 소홀히 한 경우
 회사의 관리영역이 아닌 공중통신선로의 장애로 서비스이용이 불가능한 경우
 기타 회사의 귀책사유가 없는 통신서비스 등의 장애로 인한 경우
 회사는 회원이 유료서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것, 서비스에 게시된 게시물에 대한 취사 선택 또는 이용으로 발생하는 손해 등에 대해서는 책임을 지지 않습니다. 또한 회원이 사이트에 게재한 리뷰, 평점 등 게시물의 정확성 등 내용에 대하여는 책임을 지지 않습니다.
  
 회사는 회원 상호간 또는 회원과 제3자 상호간에 유료서비스와 관련하여 발생한 분쟁에 대하여 개입할 의무가 없으며, 회사에 귀책사유가 없는 한 이로 인하여 발생한 손해를 배상할 책임이 없습니다.
  
 제17조 (분쟁의 해결)
  
 유료서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 회사와 회원은 분쟁의 해결을 위해 성실히 협의하고, 협의가 안될 경우 콘텐츠산업진흥법 상 콘텐츠분쟁 조정 위원회에 분쟁조정을 신청할 수 있습니다.
  
 전항에 따라 분쟁이 해결되지 않을 경우 양 당사자는 소를 제기할 수 있으며, 회사와 회원 간의 소의 관할은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우 거소를 관할하는 지방법원의 전속 관할로 합니다.
  
 제소 당시 회원의 주소 또는 거소가 분명하지 않은 경우에는 민사소송법에 따라 관할법원을 정합니다.`,
    };
  },
};
</script>
<style lang="scss" scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css");

.wrapper {
  font-family: "Pretendard", "Malgun Gothic", "맑은고딕", sans-serif;
  padding: 56px 20px;
  background-color: #f3f4f6;

  .title {
    font-size: 24px;
    font-weight: 700;
    color: #18181b;
    text-align: center;
    margin-bottom: 36px;
  }

  > div {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px;
    background-color: #fff;
    border-radius: 26px;

    .text0 {
      font-weight: 700;
      color: #374151;
      padding-bottom: 24px;
      border-bottom: 1px solid #d1d5db;
      margin-bottom: 28px;
    }

    .text1 {
      font-size: 14px;
      color: #374151;
      line-height: 20px;
      white-space: pre-line;
    }
  }
}
</style>
